import React from 'react'
import Skills from '../../Components/Skills/Skills'

import MyPortfolioPic from '../../Images/PortfolioPic.png'
import './About.css'
function About() {
    let age = new Date().getFullYear() - Number(2002)
    return (
        <div id='About' >
            <div className='titlecontainer'>
                <h2>About</h2>
            </div>
            <p className='about-mydescription-container'>
                I am Rony Parmar, a creative full-stack developer and solution developer with a passion for crafting innovative digital experiences and capturing moments through photography.
            </p>
            <div className='about-me'>
                <img className='my-portfolio-pic' src={MyPortfolioPic} alt='MyPortfolioPic'></img>
                <div className='about-my-details'>
                    <h3>Full-Stack Developer</h3>
                    <p>I have an overwhelming passion for resolving my client's issues, creating custom web-based solutions, and providing amazing user experiences while making sure they are entirely satisfied at every stage. </p>
                    <ul>
                        <li><i class="bx bx-chevron-right"></i><strong>Age</strong><p>{age}</p></li>
                        <li><i class="bx bx-chevron-right"></i><strong>Experience</strong><p>1+ Year(s)</p></li>
                        <li><i class="bx bx-chevron-right"></i><strong>Languages Known</strong><p>English</p></li>
                        <li><i class="bx bx-chevron-right"></i><strong>Highest Degree</strong><p>M.Sc. Computational Science</p></li>
                        <li><i class="bx bx-chevron-right"></i><strong>Phone</strong><p>+1 (437) 955-5119</p></li>
                        <li><i class="bx bx-chevron-right"></i><strong>Email</strong><p>ronyparmar2107@gmail.com</p></li>
                        <li><i class="bx bx-chevron-right"></i><strong>City</strong><p>Sudbury, Ontario, Canada</p></li>
                        <li><i class="bx bx-chevron-right"></i><strong>Freelancer</strong><p>Available</p></li>
                    </ul>
                    <p>I have practical expertise creating web-based solutions with the .NET Framework, .NET MVC and the MERN stack, producing scalable, effective, and user-focused apps.</p>
                </div>
            </div>
            <Skills />
        </div>
    )
}

export default About